import LoadingConstants from 'app/shared/constants/LoadingConstants';
import DispatchConstants from 'app/shared/constants/DispatchConstants';

const getDateLimit = () => {
    const date = new Date();
    date.setFullYear(date.getFullYear() - 3);
    return date;
};

const initFilters = () => ({
    startDate: {
        title: 'Start Date',
        value: null,
        defaultValue: getDateLimit(),
        type: 'DATE',
        extraProps: {
            disableFuture: true,
            isDateEnabled: (targetDate, filters) => {
                const dateLimit = new Date();
                dateLimit.setFullYear(dateLimit.getFullYear() - 3);
                if (targetDate < dateLimit) {
                    return false;
                }
                const { endDate } = filters;
                if (endDate && endDate.value) {
                    if (targetDate > new Date(endDate.value)) {
                        return false;
                    }
                }
                return true;
            },
        },
    },
    endDate: {
        title: 'End Date',
        value: null,
        defaultValue: new Date(),
        type: 'DATE',
        extraProps: {
            disableFuture: true,
            isDateEnabled: (targetDate, filters) => {
                const dateLimit = new Date();
                dateLimit.setFullYear(dateLimit.getFullYear() - 3);
                if (targetDate < dateLimit) {
                    return false;
                }
                const { startDate } = filters;
                if (startDate && startDate.value) {
                    if (targetDate < new Date(startDate.value)) {
                        return false;
                    }
                }
                return true;
            },
        },
    },
    property: {
        title: 'Property',
        value: [],
        defaultValue: null,
        type: 'MULTISELECT',
    },
    city: {
        title: 'City',
        value: [],
        defaultValue: null,
        type: 'MULTISELECT',
    },
    state: {
        title: 'State',
        value: [],
        defaultValue: null,
        type: 'MULTISELECT',
    },
});

const mapOptions = (options) => {
    if (!options) return [];
    return options.map(option => ({
        label: option,
        isChecked: false,
    })).sort();
};

const checkFilters = (filters) => {
    for (const key in filters) {
        if (filters[key].value) return true;
    }
    return false;
};

const invoiceSort = (a, b) => {
    const dateDif = new Date(b.invoiceDate) - new Date(a.invoiceDate);
    if (dateDif !== 0) {
        return dateDif;
    }
    const propertyA = (a.propertyNames && a.propertyNames[0]) ? a.propertyNames[0] : '';
    const propertyB = (b.propertyNames && b.propertyNames[0]) ? b.propertyNames[0] : '';
    return propertyA.localeCompare(propertyB);
};

const initState = () => ({
    invoices: [],
    offset: 0,
    hasMoreData: false,
    isFilterEnabled: false,
    filter: null,
    errorMsg: null,
    loadingState: LoadingConstants.INITIAL,
    filters: initFilters(),
    multiFamilyPropertyList: [],
});

const invoiceList = nameSpace => (state = initState(), action = {}) => {
    const { type } = action;

    switch (type) {
        case `${nameSpace}${DispatchConstants.BILLING_SET_LOADING_STATE}`:
            return {
                ...state,
                loadingState: action.payload,
            };
        case `${nameSpace}${DispatchConstants.BILLING_SET_ERROR_MESSAGE}`:
            return {
                ...state,
                errorMsg: action.payload,
            };
        case `${nameSpace}${DispatchConstants.BILLING_SET_FILTERS}`:
            return {
                ...state,
                filters: action.payload,
                invoices: [],
                offset: 0,
                hasMoreData: false,
                errorMsg: null,
                isFilterEnabled: checkFilters(action.payload),
            };
        case `${nameSpace}${DispatchConstants.BILLING_IMPORT_INVOICES}`:
            return {
                ...state,
                invoices: [...state.invoices, ...action.invoices.sort(invoiceSort)],
                offset: action.offset + 1,
                hasMoreData: action.hasMoreData,
                lastZuoraSyncTime: action.lastZuoraSyncTime,
            };
        case `${nameSpace}${DispatchConstants.BILLING_CLEAR_INVOICES}`:
            return initState();
        case `${nameSpace}${DispatchConstants.BILLING_SET_MULTIFAMILY_FILTER_OPTIONS}`:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    property: {
                        ...state.filters.property,
                        value: mapOptions(action.payload.propertyNames),
                    },
                    city: {
                        ...state.filters.city,
                        value: mapOptions(action.payload.cities),
                    },
                    state: {
                        ...state.filters.state,
                        value: mapOptions(action.payload.states),
                    },
                },
            };
        default:
            return state;
    }
};

export default invoiceList;
